// extracted by mini-css-extract-plugin
export default {"advantage":"Advantage_advantage__mr3HP","cardWrapper":"Advantage_cardWrapper__N3reQ"};